import { useState, useEffect, useRef } from 'react';
import { categories } from '@/mocks/categories';

interface CategoryDropdownProps {
  label: string;
}

export default function CategoryDropdown({ label }: CategoryDropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="relative w-full max-w-md" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 whitespace-nowrap rounded-lg border border-background-300/60 bg-background-50 px-4 py-3 text-left text-sm font-medium text-foreground-800 hover:border-primary-300 transition-colors"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2">
          <i className="ri-list-unordered text-base text-primary-600" />
          {label}
        </span>
        <i className={`ri-arrow-down-s-line text-base transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute z-30 mt-2 max-h-96 w-full overflow-y-auto rounded-lg border border-background-200/70 bg-background-50 p-1">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-100/70 hover:text-primary-900 transition-colors"
            >
              <span className="flex items-center gap-2.5">
                <span className="flex h-6 w-6 items-center justify-center overflow-hidden rounded-md">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="h-full w-full object-cover"
                  />
                </span>
                {cat.name}
              </span>
              <i className="ri-arrow-right-up-line text-sm text-foreground-400" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}